import { render } from "./AuthLayout.vue?vue&type=template&id=ad807194"
const script = {}
script.render = render

export default script